import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import useAuth from "../hooks/useAuth";
import {Link, useNavigate} from "react-router-dom";
import {Fragment} from "react";
import useLogout from "../hooks/useLogout";


export default function UserButtonMenu() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);


  const signOut = async () => {
    await logout();
    navigate('/login');
  }

  const navigate = useNavigate();
  const logout = useLogout();


  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);

  };


  const handleClose = () => {
    setAnchorEl(null);
  };

  const { auth } = useAuth();

  return (
    <Fragment>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        title={auth?.email && 'Welcome ' + auth.email}
      >
        <AccountCircleIcon style={{fontSize: '48px'}} />


      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem component={Link} to={"/account"}>My Account</MenuItem>
        <MenuItem component={Link} to={"/orders/paginated"}>My Orders</MenuItem>
        <MenuItem component={Link} to={"/address-book"}>Address Book</MenuItem>
        <MenuItem component={Link} onClick={signOut}>Logout</MenuItem>
      </Menu>
    </Fragment>
  );
}
